'use strict';
angular
    .module('dnapp')
    .factory('DN.Core', [function () {
        function Methods() {
            // Place core functions here
            this.getQueryString = function (name) {
                name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
                var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
                results = regex.exec(location.search);
                return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
            }
        }

        return new Methods();
    }]);